// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"page_wrapper__TpAvp","search-wrapper":"page_search-wrapper__aQhio","layout":"page_layout__nAeT_","back":"page_back__gpK8V"};